import React, { useState, useEffect } from "react";
import { Link, redirect } from "react-router-dom";
import { Col, Container, Form, Row, Input, Label, FormFeedback } from "reactstrap";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// import images
import logodark from "../../assets/images/main-logo-dark.png";
import logolight from "../../assets/images/main-logo-dark.png";
import CarouselPage from "./CarouselPage";
// import {login} from "../../helpers/AuthType/fakeBackend";
import { useNavigate, Navigate  } from 'react-router-dom';
// import { Store } from "redux";
import { authLoginThunks, RootState } from "../../store";
import { useSelector } from 'react-redux';
import { useThunk } from '../../hooks/use_thunk';
import { toast } from "react-toastify";

const Login2 : React.FC = () => {
  const { runThunk: doLogin, isLoading: isLoadingLogin, error: loadingLoginError } = useThunk(authLoginThunks);
  const navigate = useNavigate();
  const [passwordShow, setPasswordShow] = useState<boolean>(false);
  const authState = useSelector((state: RootState) => state.auth.token);



  // //meta title
  document.title = "E-water нэвтрэх";
  
  useEffect(()=>{
    if(loadingLoginError)
      {
        
        let msg=loadingLoginError['message'];
        if(loadingLoginError['message']=='Invalid credentials')
        {
          msg= 'Хэрэглэгчийн нэр эсвэл нууц үг буруу байна';
        }
        toast.error(msg);
      }
  }, [loadingLoginError]);

  // navigate('/dashboard');
  // useEffect(()=>{
  //   if(authState)
  //   {
  //     console.log(authState, 'end bn');
  //     navigate('/dashboard');
  //   }
  // },[authState]);


  // // Form validation 
  const validation : any = useFormik({
    enableReinitialize: true,
    initialValues: {
      username: '',
      password: '',
    },
    validationSchema: Yup.object({
      username: Yup.string().required("Хэрэглэгчийн нэвтрэх нэр оруулна уу"),
      password: Yup.string().required("Хэрэглэгчийн нууц үг оруулна уу"),
    }),
    onSubmit: (values: any) => {
      doLogin({...values, "successTxt": "Амжилттай нэвтэрлээ"});
    }
  });
  if (authState) {
    return <Navigate to="/dashboard" />;
  }
  return (
    <React.Fragment>
      <div>
        <Container fluid className="p-0">
          <Row className="g-0">
            <CarouselPage />

            <Col xl={3}>
              <div className="auth-full-page-content p-md-5 p-4">
                <div className="w-100">
                  <div className="d-flex flex-column h-100">
                    <div className="mb-4 mb-md-5">
        
                    </div>
                    <div className="my-auto">
                      <div>
                        <h5 className="text-primary">Welcome Back !</h5>
                        <p className="text-muted">
                          Усны мэдээллийн санд тавтай морил
                        </p>
                      </div>

                      <div className="mt-4">
                        <Form className="form-horizontal"
                          onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                            return false;
                          }}
                        >
                          <div className="mb-3">
                            <Label className="form-label">Нэвтрэх нэр</Label>
                            <Input
                              name="username"
                              className="form-control"
                              placeholder="Нэвтрэх нэр"
                              type="text"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.username || ""}
                              invalid={
                                validation.touched.username && validation.errors.username ? true : false
                              }
                            />
                            {validation.touched.username && validation.errors.username ? (
                              <FormFeedback type="invalid">{validation.errors.username}</FormFeedback>
                            ) : null}
                          </div>

                          <div className="mb-3">
                            <div className="float-end">
                              <Link to="/auth-recoverpw-2" className="text-muted">Нууц үг сэргээх?</Link>
                            </div>
                            <Label className="form-label">Нууц үг</Label>
                            <div className="input-group auth-pass-inputgroup">
                              <Input
                                name="password"
                                value={validation.values.password || ""}
                                type={passwordShow ? "text" : "password"}
                                placeholder="Нэвтрэх нууц үг"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                invalid={
                                  validation.touched.password && validation.errors.password ? true : false
                                }
                              />
                              <button onClick={() => setPasswordShow(!passwordShow)} className="btn btn-light " type="button" id="password-addon">
                                <i className="mdi mdi-eye-outline"></i></button>
                            </div>
                            {validation.touched.password && validation.errors.password ? (
                              <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                            ) : null}
                          </div>

                          <div className="form-check">
                            <Input
                              type="checkbox"
                              className="form-check-input"
                              id="auth-remember-check"
                            />
                            <label
                              className="form-check-label"
                              htmlFor="auth-remember-check"
                            >
                              Хэрэглэгч санах
                            </label>
                          </div>

                          <div className="mt-3 d-grid">
                            <button
                              className="btn btn-primary btn-block "
                              type="submit"
                            >
                              Нэвтрэх
                            </button>
                          </div>

                        </Form>

                        {/* <Form action="dashboard">
                          <div className="mt-4 text-center">
                            <h5 className="font-size-14 mb-3">
                              
                            </h5>

                            <ul className="list-inline">
                              <li className="list-inline-item">
                                <Link
                                  to="#"
                                  className="social-list-item bg-primary text-white border-primary me-1"
                                >
                                  <i className="mdi mdi-facebook"></i>
                                </Link>
                              </li>
                              <li className="list-inline-item">
                                <Link
                                  to="#"
                                  className="social-list-item bg-info text-white border-info me-1"
                                >
                                  <i className="mdi mdi-twitter"></i>
                                </Link>
                              </li>
                              <li className="list-inline-item">
                                <Link
                                  to="#"
                                  className="social-list-item bg-danger text-white border-danger"
                                >
                                  <i className="mdi mdi-google"></i>
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </Form> */}
                        {/* <div className="mt-5 text-center">
                          <p>
                            Don&apos;t have an account ?
                            <Link
                              to="/Register"
                              className="fw-medium text-primary"
                            >
                              Signup now
                            </Link>
                          </p>
                        </div> */}
                      </div>
                    </div>

                    <div className="mt-4 mt-md-5 text-center">
                      <p className="mb-0">
                        © {new Date().getFullYear()} Усны мэдээллийн сан. Хөгжүүлэлт & Загвар{" "}
                         <br/>
                        ЭРХЭТ ИННОВАЦИ ХХК
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Login2;
